<template>
	<div class=" padding-left-30 padding-right-30">
		<div class="vctb-list">
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="vctbIndex=0">
				工商信息
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="vctbIndex=1">
				股东信息 ({{totalnum}})
			</div>
		</div>

		<div class=" padding-left-10 padding-right-10">

			<template v-if="vctbIndex==0">
				<table class="pure-table pure-table-bordered">
					<tbody>
						<tr>
							<td style="width:15%;background: #F7F7F7;">统一社会信用代码</td>
							<td>{{detail.code ? detail.code : '--'}}</td>
							<!-- node -->
							<td style="width: 15%;background: #F7F7F7;">注册号</td>
							<td>{{detail.industry_number ? detail.industry_number : '--'}}</td>
						</tr>

						<tr>
							<td style="background: #F7F7F7;">组织机构代码</td>
							<td>{{detail.organi_code ? detail.organi_code : '--'}}</td>
							<td style="background: #F7F7F7;">经营状态</td>
							<td>{{detail.operate_status ? detail.operate_status : '--'}}
							</td>
						</tr>
						<tr>
							<td style=" background: #F7F7F7;"> 法定代表人
							</td>
							<td> {{detail.legal ? detail.legal : '--'}} </td>
							<td style="background: #F7F7F7;">注册资本</td>
							<td>{{detail.capital ? detail.capital : '--'}}</td>
						</tr>
						<tr>

							<td style=" background: #F7F7F7;">企业类型</td>
							<td colspan="">{{detail.com_type ? detail.com_type : '--'}}</td>
							<td style=" background: #F7F7F7;">成立日期</td>
							<td colspan="">{{detail.date ? detail.date : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">营业期限</td>
							<td>{{detail.business_term ? detail.business_term : '--'}}</td>
							<td style="background: #F7F7F7;">登记机关</td>
							<td>{{detail.register_local ? detail.register_local : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">核准日期</td>
							<td>{{detail.approval_date ? detail.approval_date : '--'}}</td>
							<!-- node -->
							<td style="background: #F7F7F7;">公司规模</td>
							<td>{{detail.people_size ? detail.people_size : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">参保人数</td>
							<td>{{detail.insure_number ? detail.insure_number : '0'}}人</td>
							<!-- <td>--</td> -->
							<td style="background: #F7F7F7;">年营业额</td>
							<td>{{detail.tax_number ? detail.tax_number : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">所属行业</td>
							<td colspan="3">{{detail.industry ? detail.industry : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">通讯地址</td>
							<td colspan="3">{{detail.address ? detail.address : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">注册地址</td>
							<td colspan="3">{{detail.new_address ? detail.new_address : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">最新注册地址变更日期</td>
							<td colspan="3">{{detail.addressLastChangeDate ? detail.addressLastChangeDate : '--'}}</td>
						</tr>
						<tr>
							<td style="background: #F7F7F7;">经营范围</td>
							<td colspan="5">{{detail.business ? detail.business : '--'}}</td>
						</tr>

						<!-- <tr>
					<td style=" background: #F7F7F7;">企业类型名称</td>
					<td>{{detail.com_type ? detail.com_type : '--'}}</td>
				</tr>
				<tr>
					<td style="width: 10%;background: #F7F7F7;">曾用名</td>
					<td>{{detail.usedname ? detail.usedname : '--'}}</td>
				</tr> -->
					</tbody>
				</table>
				<div class="height-30"></div>
			</template>

			<template v-if="vctbIndex==1">
				<div v-if="detail">
					<div class="box5 box2_cc">
						<!-- 	<div class="box5_text1 text-bold" style="  width: 22%;">序号
					</div> -->
						<div class="box5_text2 text-bold " style="flex:2;">股东(发起人)
						</div>
						<div class="box5_text2 text-bold ">持股比例
							<el-tooltip class="item" effect="dark" content="默认采用认缴出资金额计算" placement="top">
								<i class="el-icon-warning-outline margin-left-4"></i>
							</el-tooltip>
						</div>
						<div class="box5_text2 text-bold">认缴出资金额 </div>
						<div class="box5_text2 text-bold">认缴出资日期 </div>
						<div class="box5_text2 text-bold">实缴出资金额 </div>
						<div class="box5_text2 text-bold">实缴出资日期 </div>
						<div class="box5_text2 text-bold width-80 justify-center" style="flex:none;">操作</div>
						<!-- <div class="box5_text2 text-center" >实缴出资额</div> -->
					</div>
					<div v-for="(item, index) in shareholder" :key="index" class="box5">
						<!-- <div class="box5_text1 text-center" style="width: 22%;">
						<div class="response text-center">{{ index+1 }}</div>
					</div> -->
						<div class="box5_text2  " style="flex:2;">
							{{item.name}}
						</div>
						<div class="box5_text2  ">{{ item.share_rate||"0%" }} </div>
						<div class="box5_text2  ">{{ item.money }}</div>
						<div class="box5_text2  ">{{ item.date||"--" }}</div>
						<div class="box5_text2  ">{{ item.payedNumber||"--" }}</div>
						<div class="box5_text2  ">{{ item.payedDate||"--" }}</div>
						<div class="box5_text2  justify-center  width-80  " style="flex:none;">
							<span class="cpoint" style="color: #0070c0;" @click="showShareholder(item)">详情</span>
						</div>
						<!-- <div class="box5_text2 text-center">xxxxx</div> -->
					</div>
					<div class="padding-bottom-40" v-if="!shareholder.length">
						<nomore></nomore>
					</div>
					<div  class="text-right" style="padding: 30px 0">
						<el-pagination background :page-size="pagesize" :page-sizes="pageSizes"
							:hide-on-single-page="false" layout="prev, pager, next,sizes"
							@size-change="handleSizeChange" @current-change="handleCurrentChange($event)"
							:current-page="currentPage" :total="totalnum">
						</el-pagination>
					</div>
				</div>
			</template>

		</div>




		<el-dialog title="股东信息" :visible.sync="dialogTableVisible">
			<table class="pure-table pure-table-bordered">
				<tbody>
					<tr>
						<td style="width:40%;background: #F7F7F7;">股东(发起人)</td>
						<td>{{shareholderData.name||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">持股比例</td>
						<td>{{shareholderData.share_rate||"0%" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">认缴出资方式</td>
						<td>{{shareholderData.planPayedMode || '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">认缴出资金额</td>
						<td>{{shareholderData.money|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">认缴出资日期</td>
						<td>{{shareholderData.date|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">认缴公式日期</td>
						<td>{{shareholderData.publicDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">实缴出资方式</td>
						<td>{{shareholderData.payedMode ||'--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">实缴出资金额</td>
						<td>{{shareholderData.payedNumber|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">实缴出资日期</td>
						<td>{{shareholderData.payedDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">实缴公式日期</td>
						<td>{{shareholderData.planPublicDate || '--'}}</td>
					</tr>


				</tbody>
			</table>

		</el-dialog>




	</div>
</template>

<script>
	export default {
		props: {
			id: {
				type: [String, Number],
				default: ""
			},
			detail: {
				type: Object,
				default: ""
			}
		},
		data() {
			return {
				totalnum: 0,
				change_record: "",
				token: "",
				totalnum: 0,
				currentPage: 1,
				pagesize: 10,
				type: 0,
				type1: 0,
				shareholder: [],
				people_list: [],
				vctbIndex: 0,
				dialogTableVisible: false,
				shareholderData: {},
				pageSizes: [10, 20, 30, 40, 50]
			}
		},
		methods: {
			showShareholder(data) {
				this.shareholderData = data
				this.dialogTableVisible = true
			},
			getshare() {
				//enterprise_support
				var api = this.$api.api.companydata.shareholder_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.currentPage,
						page_size: this.pagesize,
						id: this.id
					},
					(response) => {
						// console.log("response", response);
						this.shareholder = response.data;
						this.totalnum = response.count;
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getshare();
			},
			handleSizeChange(size) {
				this.pagesize = size
				this.currentPage = 1;
				this.getshare();
			},
			toout(href) {
				// console.log(href)
				if (!href) {
					return false;
				}
				window.open(href)
			},
		},
		created() {
			// this.token = localStorage.getItem('userid') ? localStorage.getItem('userid') : '';
			this.getshare();
			// this.getchange()

		}
	}
</script>

<style lang="scss" scoped>
	@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// detail-page.vue?cf9a1308